import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';

const HeroBanner = () => {
  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 4,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(https://businessdayghana.com/wp-content/uploads/2025/02/hajj-hero-2.jpg)`,
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.5)',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          p: { xs: 3, md: 6 },
          pr: { md: 0 },
          minHeight: 300,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Typography component="h1" variant="h3" color="inherit" gutterBottom>
          Trouvez le forfait Hajj idéal
        </Typography>
        <Typography variant="h5" color="inherit" paragraph sx={{ maxWidth: '50%' }}>
          Comparez les meilleures offres des compagnies de voyage spécialisées
        </Typography>
        <Button variant="contained" color="secondary" sx={{ width: { xs: '100%', sm: 'auto' }, mt: 2, alignSelf: { xs: 'center', sm: 'flex-start' } }}>
          Explorer les forfaits
        </Button>
      </Box>
    </Paper>
  );
};

export default HeroBanner;